module.exports = __webpack_public_path__ + "static/img/4_1_4.22d0179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_4.png
// module id = gzYo
// module chunks = 1